import * as React from 'react';
import PageMobileContent from '~/common/layout/PageMobileContent';
import TransactionHistory from '../containers/transactions/TransactionHistory';


export default function() {
  return (
    <React.Fragment>
      <PageMobileContent>
        <TransactionHistory />
      </PageMobileContent>
    </React.Fragment>
  );
};
